module.exports = __webpack_public_path__ + "static/media/so.6e5f1337.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/so.svg
// module id = 251
// module chunks = 0